<template>
  <div class="h-100 d-flex flex-column overflow-auto">
    <template v-if="isDetail">
      <div class="bg-white border-bottom pt-3 shadow-sm">
        <div class="container-xl">
          <VendorHeader
            ref="header"
            v-if="hasResource"
            :resource="resource"
            :page-active="pageCurrent"
            @navigate="onNavigate"
          />
        </div>
      </div>

      <div
        id="detail-area"
        class="flex-fill d-flex flex-column w-100"
      >
        <div
          v-if="hasResource"
          :class="[pageContainerClass, 'h-100']"
        >
          <VendorSummary
            v-if="pageCurrent == 'summary'"
            :resource="resource"
            @resource:updated="onUpdatedResource"
          />

          <VendorLocationsGrid
            v-if="pageCurrent == 'locations'"
            :resource="resource"
            @resource:updated="onUpdatedResource"
          />

          <!-- use_vendor_sites tenants: CompanySite instead of CompanyLocation -->
          <VendorSitesTab
            v-if="pageCurrent == 'sites'"
            :resource="resource"
            @resource:refresh="onRefreshResource"
          />

          <VendorContacts
            v-if="pageCurrent == 'contacts'"
            :resource="resource"
            @resource:updated="onUpdatedResource"
          />

          <VendorSourcing
            v-if="pageCurrent == 'sourcing'"
            :resource="resource"
          />

          <VendorQuality
            v-if="pageCurrent == 'quality_scorecards'"
            :resource="resource"
          />

          <VendorQualityIssues
            v-if="pageCurrent == 'quality'"
            :resource="resource"
            class="py-3"
          />

          <!-- ONLY FOR LOCAL DEV FOR NOW -->
          <VendorPerformanceDemo
            v-if="$splEnvIsDev && pageCurrent == 'performance_demo'"
            :resource="resource"
          />
          <VendorPerformance
            v-if="pageCurrent == 'performance'"
            :resource="resource"
          />

          <!-- ONLY FOR LOCAL DEV FOR NOW -->
          <!-- <VendorCompliance
            v-if="pageCurrent == 'compliance'"
            :resource="resource"
          /> -->

          <VendorDocuments
            v-if="pageCurrent == 'documents'"
            :resource="resource"
          />

          <VendorFiles
            v-if="pageCurrent == 'files'"
            :resource="resource"
          />

          <VendorNotes
            v-if="pageCurrent == 'notes'"
            :resource="resource"
          />
        </div>
      </div>
    </template>
    <VendorList v-else />
  </div>
</template>

<script>
  import { suppliosApi } from '@/js/api-service';
  import VendorList from '@/components/vendors/pages/VendorList';
  import VendorHeader from '@/components/vendors/components/VendorHeader';
  import VendorSummary from '@/components/vendors/pages/VendorSummary';
  import VendorLocationsGrid from '@/components/vendors/pages/VendorLocationsGrid.vue';
  import VendorSitesTab from '@/components/vendors/pages/VendorSitesTab.vue';
  import VendorContacts from '@/components/vendors/pages/VendorContacts';
  import VendorSourcing from '@/components/vendors/pages/VendorSourcing';
  import VendorQuality from '@/components/vendors/pages/VendorQuality';
  import VendorQualityIssues from '@/components/vendors/pages/VendorQualityIssues';
  import VendorFiles from '@/components/vendors/pages/VendorFiles';
  import VendorNotes from '@/components/vendors/pages/VendorNotes';
  import VendorPerformance from '@/components/vendors/pages/VendorPerformance';
  import VendorPerformanceDemo from '@/components/vendors/pages/VendorPerformanceDemo';
  // import VendorCompliance from '@/components/vendors/pages/VendorCompliance.vue';
  import VendorDocuments from '@/components/vendors/pages/VendorDocuments.vue';

  export default {
    components: {
      VendorList,
      VendorHeader,
      VendorSummary,
      VendorLocationsGrid,
      VendorSitesTab,
      VendorContacts,
      VendorSourcing,
      VendorQuality,
      VendorQualityIssues,
      VendorFiles,
      VendorNotes,
      VendorPerformance,
      VendorPerformanceDemo,
      // VendorCompliance,
      VendorDocuments,
    },
    props: {
      resourceId: {
        type: String,
        default: '',
      },
      pageActive: {
        // initial page to show, we have logic that checks for allowed values - make sure it handles this being null/undefined/empty string
        type: String,
        default: '', // no default... we check in created and set there if its valid
      },
    },
    data() {
      return {
        resourceType: 'Vendor', // was a prop, but not using this junk resource pattern much, so just hard-code for now
        resource: null, // previously passed in as prop, now we'll fetch it
        api: suppliosApi.vendorStandard,
        pageCurrent: 'summary', //this.pageActive
        pageSettings: {
          'summary': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'sites': {
            container: 'fluid',  // 'xl' or 'fluid'
          },
          'locations': {
            container: 'fluid',  // 'xl' or 'fluid'
          },
          'contacts': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'sourcing': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'quality_scorecards': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'quality': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'performance_demo': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'performance': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'compliance': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'documents': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'files': {
            container: 'xl',  // 'xl' or 'fluid'
          },
          'notes': {
            container: 'xl',  // 'xl' or 'fluid'
          }
        },
        // knownPages: ['summary', 'sites', 'locations', 'contacts', 'sourcing', 'quality_scorecards', 'quality', 'performance_demo', 'performance', 'compliance', 'documents', 'files', 'notes'],
      };
    },
    computed: {
      // api() {
      //     // not passing in full resource as prop now
      //     // pass in 'resourceId' and 'resourceType' instead
      //     // also useful since not all endpoint names exactly match resource type
      //     //const resourceType = this.resourceType;
      //     const namespace = this.resourceType.toLowerCase();
      //     const endpointName = `${namespace}Standard`;
      //     return suppliosApi[endpointName];
      // },
      isDetail() {
        return this.resourceId || this.resource;
      },
      hasResource() {
        return !!this.resource?.id;
      },
      pageContainerClass() {
        const size = this.pageSettings[this.pageCurrent]?.container || 'xl';
        return `container-${size}`;
      },
    },
    created() {
      this.pageCurrent = !!this.pageActive && Object.keys(this.pageSettings).includes(this.pageActive) ? this.pageActive : 'summary';
    },
    beforeMount() {
      // Mark added 'resourceId' prop -
      // why? to avoid passing resourceData from django template, which was how resourceData was being passed before
      // - instead, we'll just pass resourceId in template, then if we have resourceId but no this.resource, we'll fetch the resource here
      if (this.isDetail && !this.resource) {
        this.onRefreshResource(); // fetch it, populate this.resource
      }
    },
    methods: {
      onNavigate(payload) {
        this.pageCurrent = payload;
      },
      onUpdatedResource(data) {
        const dataToMerge = data ? data : {};
        const resource = this.resource ? Object.assign(this.resource, dataToMerge) : Object.assign({}, dataToMerge);
        // make sure we have type in there for now at least...
        if (!resource.type && this.resourceType) {
          resource['type'] = this.resourceType;
        }
        this.resource = resource;
      },
      async onRefreshResource() {
        const id = this.resourceId || this.resource.id;
        const response = await this.api.retrieve(id);
        this.onUpdatedResource(response.data);
      },
    },
  };
</script>

<style></style>
